import apiUrl from "../../../../utils/settings";

export const dealerCompanyBaseProductPriceUrl = () => {
  return apiUrl + '/product-prices/get-company-base-product-price';
};